var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.188 4.688h10.874M1.313 4.688h4.875M9.938 1.688h-3.75v6h3.75v-6zM12.188 19.688h10.874M1.313 19.688h4.875M9.938 16.688h-3.75v6h3.75v-6zM20.438 12.188h2.625M1.313 12.188h13.124M18.188 9.188h-3.75v6h3.75v-6z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
export default SvgFilter;